import { Config } from "../config/config.js";
import { Helper } from "../util/helper.js";
import React from "react";
export class RSplitter extends React.Component<RSplitterProps, RSplitterState> {
    private _wrapper: HTMLDivElement = null;
    private _handleSize = 5;
    private _tolerance = 3;


    constructor(props: RSplitterProps) {
        super(props);

        this.state = {
            first: this.loadSplitterPercentage(),
            id: kendo.guid().toString()
        };
    }

    public getWrapperRef = () => {
        return this._wrapper;
    }

    private _setWrapperRef = (ref: HTMLDivElement) => {
        this._wrapper = ref;
    };

    private _onResizeEnd = (newPosition: number) => {
        const rect = this._wrapper.getBoundingClientRect();
        const delta = this.props.direction === RSplitterDirection.Vertical ? (newPosition - rect.top) : (newPosition - rect.left);
        const p = (delta * 100) / (this.props.direction === RSplitterDirection.Vertical ? this._wrapper.offsetHeight : this._wrapper.offsetWidth);
        this.setState({ first: p }, () => this.afterResize(p));
    };

    private afterResize = (percent: number) => {
        if (this.props.rememberPercentage && Helper.hasValue(this.props.id)) {
            this.saveSpliterPercentageToLocalStroage(percent);
        }
        if (Helper.hasValue(this.props.afterResize)) {
            this.props.afterResize();
        }
    }

    private _getStyles = (numberOfChildren: number, hideSecond: boolean) => {
        const vertical = this.props.direction === RSplitterDirection.Vertical;

        //@ts-ignore
        const wrapper: React.CSSProperties = {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: vertical ? "column" : "row"
        };
        
        //@ts-ignore
        const first: React.CSSProperties = {
            height: vertical ? (numberOfChildren === 1 ? "100%" : `${this.state.first}%`) : null,
            width: vertical ? null : (numberOfChildren === 1 ? "100%" : `${this.state.first}%`),
            overflow: "auto"
        };

        //@ts-ignore
        const subsequent: React.CSSProperties = {
            height: vertical ? (numberOfChildren === 1 ? "0" : `${100 - this.state.first}%`) : null,
            width: vertical ? null : (numberOfChildren === 1 ? "0" : `${100 - this.state.first}%`),
            overflow: "auto",
            display: hideSecond ? "none" : null
        };

        return {
            wrapper,
            first,
            subsequent
        };
    }

    private loadSplitterPercentage = () => {
        let percentage: any;
        if (this.props.rememberPercentage && Helper.hasValue(this.props.id)) {
            percentage = this.loadSplitterPercentageFromLocalStorage();
        }
        return percentage ?? this.props.initialPercentage ?? 50;
    }

    private loadSplitterPercentageFromLocalStorage = () => {
        const key = `SPLITTER_DEFAULT_${this.props.id}_${Config.user.userName}`;
        return Helper.loadDataFromStorage(key);
    }

    private saveSpliterPercentageToLocalStroage = (percent: number) => {
        const key = `SPLITTER_DEFAULT_${this.props.id}_${Config.user.userName}`;
        Helper.saveDataToStorage(key, percent, false);
    }


    render() {
        const notNullChildren = React.Children.map(this.props.children, x => x).filter(x => Helper.hasValue(x));
        const hideSecondContainer = this.props.shouldHideSecondContainer ? this.props.shouldHideSecondContainer() : false;
        const styles = this._getStyles(hideSecondContainer ? 1 : notNullChildren.length, hideSecondContainer);

        return (
            notNullChildren.length === 0 ?
                null
                :
                <div style={styles.wrapper} ref={this._setWrapperRef} id={this.state.id}>
                    <div style={styles.first} className="flex-container flex-container__item">
                        {notNullChildren[0]}
                    </div>
                    {
                        notNullChildren.length > 1 && !hideSecondContainer ?
                            <Handle onResizeEnd={this._onResizeEnd} handleSize={this._handleSize} direction={this.props.direction} tolerance={this._tolerance} wrapperId={this.state.id} />
                            : null
                    }
                    <div style={styles.subsequent}>
                        {notNullChildren.filter((_c, i) => i > 0)}
                    </div>
                </div>
        );
    }
}

class Handle extends React.Component<HandleProps, HandleState> {
    private _handleRef = null;
    private _stdCursorValue: string = null;


    constructor(props: HandleProps) {
        super(props);

        this.state = {
            active: false,
            offset: 0,
            prevOffset: 0
        };
    }


    private _setHandleRef = (ref: any) => {
        this._handleRef = ref;
    };

    private _getHandlePosition = () => {
        const rect: DOMRect = this._handleRef.getBoundingClientRect();
        return this.props.direction === RSplitterDirection.Vertical ? rect.top : rect.left;
    };

    private _doOnRelease = () => {
        document.body.style.cursor = this._stdCursorValue;
        if (Math.abs(this.state.offset - this.state.prevOffset) < this.props.tolerance) {
            this.setState({ active: false });
        } else {
            const offset = this.state.offset;
            const position = this._getHandlePosition();
            this.setState({ active: false, offset: 0, prevOffset: offset }, () => {
                this.props.onResizeEnd(position + offset);
            });
        }
    };

    //@ts-ignore
    private _onMouseDown = (ev: React.MouseEvent<HTMLDivElement>) => {
        if (ev.button === 0) {
            this._stdCursorValue = document.body.style.cursor;
            document.body.style.cursor = this.props.direction === RSplitterDirection.Vertical ? "row-resize" : "col-resize";
            this.setState({ active: true });
        }
    };

    private _updateDimensions = (mousePosition: number) => {
        this.setState({ offset: mousePosition - this._getHandlePosition() });
    };

    private _handleDocMouseUp = () => {
        if (this.state.active) {
            document.getElementById(this.props.wrapperId).classList.toggle('moving', false);
            this._doOnRelease();
        }
    }

    private _handleDocMouseMove = (ev: Event) => {
        const me = ev as any as MouseEvent;
        if (this.state.active && me.button === 0) {
            //prevent selection
            document.getElementById(this.props.wrapperId).classList.toggle('moving', true);
            ev.stopPropagation();
            ev.preventDefault();
            this._updateDimensions(this.props.direction === RSplitterDirection.Vertical ? me.clientY : me.clientX);
        }
    }

    private _getStyles = () => {
        const vertical = this.props.direction === RSplitterDirection.Vertical;

        //@ts-ignore
        const handle: React.CSSProperties = {
            height: vertical ? `${this.props.handleSize}px` : null,
            width: vertical ? null : `${this.props.handleSize}px`,
            backgroundColor: "#c8c8c8",
            position: "relative",
            cursor: vertical ? "row-resize" : "col-resize"
        };

        //@ts-ignore
        const ghost: React.CSSProperties = {
            position: "absolute",
            top: vertical ? `${this.state.offset}px` : null,
            left: vertical ? null : `${this.state.offset}px`,
            zIndex: 12,
            height: vertical ? `${this.props.handleSize}px` : "100%",
            width: vertical ? "100%" : `${this.props.handleSize}px`,
            backgroundColor: "lightblue",
            cursor: vertical ? "row-resize" : "col-resize",
            pointerEvents: "none"
        };

        //@ts-ignore
        const centerMark: React.CSSProperties = {
            width: vertical ? "20px" : "100%",
            height: vertical ? "100%" : "20px",
            display: "inline-block",
            backgroundColor: "darkgrey",
            position: "absolute",
            left: vertical ? "50%" : null,
            top: vertical ? null : "50%",
            transform: vertical ? "translateX(-50%)" : "translateY(-50%)"
        };

        return {
            handle,
            ghost,
            centerMark
        };
    }


    componentDidMount() {
        document.addEventListener("mouseup", this._handleDocMouseUp);
        document.addEventListener("mousemove", this._handleDocMouseMove);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this._handleDocMouseUp);
        document.removeEventListener("mousemove", this._handleDocMouseMove);
        document.getElementById(this.props.wrapperId).classList.toggle('moving', false);
    }

    render() {
        const styles = this._getStyles();

        return (
            <div style={styles.handle} onMouseDown={this._onMouseDown} ref={this._setHandleRef}>
                <span style={styles.centerMark} />
                {this.state.active ? <div style={styles.ghost} /> : null}
            </div>
        );
    }
}

//@ts-ignore
export interface RSplitterProps extends React.PropsWithChildren {
    direction: RSplitterDirection;
    initialPercentage?: number;
    afterResize?: () => void;
    shouldHideSecondContainer?: () => boolean;
    rememberPercentage?: boolean;
    id?: string;
}

export enum RSplitterDirection {
    Horizontal = 0, Vertical = 1
}

interface RSplitterState {
    first: number;
    id: string;
}

interface HandleProps {
    onResizeEnd: (newPosition: number) => void;
    handleSize: number;
    direction: RSplitterDirection;
    tolerance: number;
    wrapperId: string;
}

interface HandleState {
    active: boolean;
    offset: number;
    prevOffset: number;
}